var bighouse = bighouse || {};

bighouse.gallery = (function () {

    function init() {

        initGallery();
        bindEvents();
    }


    function bindEvents(){

        $('.js-advancedGallery').each(function(){
            var self = this;
            var galleryID = $(self).attr('data-galleryid');

            $(this).find('.js-openGallery').on('click', function(e){   
                openAll(galleryID, $(e.currentTarget).attr('data-imageindex'));
                bighouse.lightbox.open('lightbox_' + galleryID, e.currentTarget);
                //openLightbox
                e.preventDefault();
            });

            $('.js-filterGallery').on('click', function(e){
                filterGallery(galleryID, $(e.currentTarget).attr('data-filterby'));
                bighouse.lightbox.open('lightbox_' + galleryID, e.currentTarget);
                //openLightbox
                e.preventDefault();
            });
        });


        $('.js-viewPhotos').on('click', function(e){   
            let galleryID = $(e.currentTarget).attr('data-galleryid')
            openAll(galleryID, $(e.currentTarget).attr('data-imageindex'));
            bighouse.lightbox.open('lightbox_' + galleryID, e.currentTarget);
            //openLightbox
            e.preventDefault();
        });


        $('.js-closeGallery').on('click', function(e){
            //do close tasks like reseting gallery etc
            let galleryID =  $(e.currentTarget).parents('.Lightbox-content').find('.js-filteredGallery').attr('id') ;
            clearFilters(galleryID);
        });

    }

    function filterGallery(galleryID, filterby){
        $('#' + galleryID).find('.js-slides, .js-nav').slick('slickFilter','.js-filter-' + filterby).slick('refresh');
        setTimeout( ()=>{
            $('#' + galleryID).find('.js-slides, .js-nav').slick('slickGoTo', 0, true); //hack. sometimes it doesn't work first time
        }, 100);
    }

    function openAll(galleryID, startindex){
        var openAt = parseInt( startindex , 10);
        setTimeout( ()=>{
            $('#' + galleryID).find('.js-slides, .js-nav').slick('slickGoTo', openAt, true); //hack. sometimes it doesn't work first time
        }, 100);
    }


    function clearFilters(galleryID){
        $('#' + galleryID).find('.js-slides, .js-nav').slick('slickUnfilter').slick('refresh');
    }


    function initGallery(){

        var canIUseObjectFit = util.cssPropertyValueSupported('object-fit', 'contain');

        $('.js-filteredGallery').each(function(index){
            var self = this;
            var slides = $(self).find('.js-slides').attr('id');
            var nav = $(self).find('.js-nav').attr('id');

            $('#' + slides).slick({
                lazyLoad: 'ondemand',
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                prevArrow: '<button type="button" class="GallerySlides-arrows GallerySlides-arrows--prev"><span class="u-visuallyHidden">Previous</span></button>',
                nextArrow: '<button type="button" class="GallerySlides-arrows GallerySlides-arrows--next"><span class="u-visuallyHidden">Next</span></button>',
                asNavFor: '#' + nav,
                rows: 0,
                infinite: false

            });

            $('#' + slides).on('lazyLoaded', function(event, slick, image, imageSource){
                if (!canIUseObjectFit) {
                    //move image to be a background image (less accessible but if they're using IE ... )
                    $(image).parent().css('background-image', 'url("' + imageSource + '")');
                    $(image).addClass('u-hide');
                } 
            });

            $('#' + nav).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '#' + slides,
                dots: false,
                arrows: false,
                centerMode: true,
                variableWidth: true,
                focusOnSelect: true,
                rows: 0,
                infinite: false
            });

        });
    }
   




    return {
        init: init
    };
})();